import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";

const FamilyDisclaimerPopup = ({ isOpen, onRequestClose, memberid}) => {
  const [employeeDetails, setEmpDetails] = useState(null);
  const [compDetails, setCompanyDetails] = useState(null);
    const [designations, setDesignations] = useState(null);
    const [financialYearSettings, setFinancialYearSettings] = useState(null);
    const [annualCheckup, setAnnualCheckup] = useState(null);
    const [locationMapping, setLocationMapping] = useState(null);
    const [packageMapping, setPackageMapping] = useState(null);
    const [employeeEnabled, setEmployeeEnabled] = useState(null);
    const [loader, setLoader] = useState(false);
    const [designationErrorModal, setDesignationErrorModal] = useState(false);
    const [yearSettingsErrorModal, setYearSettingErrorModal] = useState(false);
    const [annualCheckupErrorModal, setAnnualCheckuperrorModal] = useState(false);
    const [packageMappingErrorModal, setPackageMappingErrorModal] = useState(false);
    const [locationMappingErrorModal, setLocationMappingErrorModal] = useState(false);
    const [employeeEnabledErrorModal, setEmployeeEnabledErrorModal] = useState(false);
    const userid = JSON.parse(localStorage.getItem("data")).userid;
  
    const navigate = useNavigate();
  
    const handleBookAppointment = () => {
        navigate(`/users/bookAnAppointmentForFamilyMember/${memberid}`);
      };
  
    const getData = async () => {
      const token = JSON.parse(localStorage.getItem("data")).token;
      setLoader(true);
      try {
        const empRes = await axios.get(`/api/employeedetails/userid=${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setEmpDetails(empRes.data);
        const compRes = await axios.get(`/api/companydetails/${empRes.data?.companyId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCompanyDetails(compRes.data);
        const designationRes = await axios.get(`/api/employeedetails/checkDesignationMapped/userid=${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setDesignations(designationRes.data);
       
        const packageRes = await axios.get(`/api/employeedetails/checkPackageMapped/userid=${userid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPackageMapping(packageRes.data);
  
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    };
  
    function handleError(error) {
      if (error.response) {
        if (error.response.status === 401) {
          navigate(`/signin`);
          toast.error("Your session has expired. Please login.");
        } else if (error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else if (error.response.data && error.response.data.code) {
          toast.error(error.response.data.code);
        } else {
          toast.error("An error occurred.");
        }
      } else if (error.message) {
        toast.error(error.message);
      } else {
        toast.error("An error occurred.");
      }
    }
  
    useEffect(() => {
      getData();
    }, []);
  
    const allDetailsTrue =
      designations?.allAccounted === true &&
      packageMapping?.allAccounted === true; 
      
    const closeDesignationErrorModal = () => {
      setDesignationErrorModal(false);
    };
  
    const closePackageErrorModal = () => {
      setPackageMappingErrorModal(false);
    };


    return (
      <>
        <Modal show={isOpen} onHide={onRequestClose} centered>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            {loader && <div className="loading"></div>}
  
          
              <div >
                <p>
                  Designation: {designations?.allAccounted === true ? "✓" : "❌"}
                  {designations?.allAccounted === false && (
                    <span style={{ marginLeft: "40px" }}>
                      <FiInfo onClick={() => setDesignationErrorModal(true)} />
                    </span>
                  )}
                </p>

            
                <p>
                  Package Mapping: {packageMapping?.allAccounted === true ? "✓" : "❌"}
                  {packageMapping?.allAccounted === false && (
                    <span style={{ marginLeft: "40px" }}>
                      <FiInfo onClick={() => setPackageMappingErrorModal(true)} />
                    </span>
                  )}
                </p>

                
                {!allDetailsTrue && (
                  <p style={{ color: "red" }}>Please contact your administration for the above issues.</p>
                )}
              </div>
  
          </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="me-3" onClick={onRequestClose}>
          Decline
        </Button>
        {allDetailsTrue && (
        <Button variant="primary" onClick={handleBookAppointment}>
          Accept
        </Button>
        )}
      </Modal.Footer>
    </Modal>
    
     <Modal show={designationErrorModal} onHide={closeDesignationErrorModal} centered>
     <Modal.Header closeButton>
       <Modal.Title>Designation Error</Modal.Title>
     </Modal.Header>
     <Modal.Body>
       <p style={{color:"red"}}>{designations?.errorMessage}</p>
     </Modal.Body>
     <Modal.Footer>
       <Button variant="secondary" onClick={closeDesignationErrorModal}>
         Close
       </Button>
     </Modal.Footer>
   </Modal>

 
   <Modal show={packageMappingErrorModal} onHide={closePackageErrorModal} centered >
     <Modal.Header closeButton>
       <Modal.Title>Package Mapping Error</Modal.Title>
     </Modal.Header>
     <Modal.Body>
       <p style={{color:"red"}}>{packageMapping?.errorMessage}</p>
     </Modal.Body>
     <Modal.Footer>
       <Button variant="secondary" onClick={closePackageErrorModal}>
         Close
       </Button>
     </Modal.Footer>
   </Modal>
   </>
  );
};

export default FamilyDisclaimerPopup;
